import { render, staticRenderFns } from "./latest-nav.vue?vue&type=template&id=ec98470c&scoped=true&"
import script from "./latest-nav.vue?vue&type=script&lang=js&"
export * from "./latest-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec98470c",
  null
  
)

export default component.exports